<template>
	<div class="detail-page">
		<!-- <PhotoPreivewPage /> -->
		<div class="skeleton-container" v-if="!inited">
			<skeleton
				v-for="(item, index) in skeletonJson"
				:key="index"
				:skeletonItem="item"
				:animation="true"
			/>
		</div>

		<nio-header-nav
			ref="headerNav"
			position="fixed"
			v-if="$isInWebview"
			:scrollListener="true"
			rightButtonShow
			:height.sync="headerHeight"
			@back="handleClose"
		>
			<div class="right-btn-list">
				<svg
					v-if="!isHarmony"
					@click="handleRightClick('icon_share_cn_medium_m')"
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M21.5122 5.5H14.5C13.6716 5.5 13 4.82843 13 4H23.35C23.5224 4 23.6877 4.06848 23.8096 4.19038C23.9315 4.31228 24 4.47761 24 4.65V15C23.1716 15 22.5 14.3285 22.5 13.5V6.64067L11.5702 18.4112C11.0065 19.0183 10.0574 19.0534 9.45037 18.4897L21.5122 5.5Z"
						fill="currentColor"
					/>
					<path
						d="M4 4.00005C4.82842 4.00002 5.5 4.67158 5.5 5.5V22.15C5.5 22.3433 5.6567 22.5 5.85 22.5L22.5 22.5C23.3284 22.5 24 23.1716 24 24H5.65C4.73873 24 4 23.2613 4 22.35V4.00005Z"
						fill="currentColor"
					/>
				</svg>
			</div>
		</nio-header-nav>
		<template v-if="!!car">
			<!-- <indicator-tabs v-if="!snapshot" :top="headerHeight" :car="car" /> -->
			<fast-listing-banner v-if="isFastListing" :car="car" />
			<banner v-else :car="car" />
			<div v-if="snapshot" class="snapshot-tips">当前页面内容为订单创建时的商品描述信息</div>
			<div class="main-content">
				<basic-card :car="car" :car-name="carName" :finance-entry="financeEntry" />

				<config-snapshot-card v-if="configSnapshot" :car="car" />
				<car-album v-if="!configSnapshot && !isFastListing" :car="car" />

				<car-report v-if="!snapshot" :car="car" />

				<car-right v-if="!snapshot" :car="car" />

				<process-card v-if="!snapshot" :car="car" />

				<recommend-cars v-if="!snapshot" :car="car" />
			</div>

			<bottom-area
				v-if="!snapshot"
				:car="car"
				:is_favorite="collected"
				@contact="showContact = true"
			/>
		</template>

		<nio-alert
			v-if="warning && car && car.basic && [2, 4].includes(car.basic.business_type)"
			type="warning"
			:showIcon="false"
			:closable="true"
			:title="warning"
			class="warning"
			:style="{ bottom: safeAreaInsetBottom + 85 + 'px' }"
		></nio-alert>

		<nio-sheet v-model="showContact">
			<contact-popup
				:show-phone="car && car.basic.business_type === 1"
				@close="showContact = false"
			/>
		</nio-sheet>
	</div>
</template>

<script>
import { NioIcon } from '@nio-fe/nio-app-ui'
import CarAlbum from '@/views1/DetailPage/CarAlbum'
import RecommendCars from '@/views1/DetailPage/RecommendCars'
import Banner from '@/views1/DetailPage/Banner'
import FastListingBanner from '@/views1/DetailPage/FastListingBanner'
import IconService from '@/assets/svg/icon_service.svg'
import BasicCard, { getCarTags } from '@/views1/DetailPage/BasicCard'
import CarReport from '@/views1/DetailPage/CarReport'
import { supreme } from '@/supreme-core'
import { queryVehicleDetail, queryVehicleSnapshot } from '@/model'
import BottomArea from '@/views1/DetailPage/BottomArea'
import util from '@/util/util'
import hybrid from '@/util/nativeHybrid'
import sensors from '@/util/dataTrack'
import ContactPopup from '@/components/ContactPopup'
import CarRight from '@/views1/DetailPage/CarRight'
import Skeleton from '@/components/Skeleton'
import { px2vw } from '@/util/unit-transfer.js'
import ConfigSnapshotCard from '@/views1/DetailPage/ConfigSnapshotCard'
import ProcessCard from '@/views1/DetailPage/ProcessCard'
import configModel from '@/model/ConfigModel'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import { getBusinessTypeLabel } from '@/components/CarTags'
import { BrandMap } from '@/util/constant'
import { getFastListingCover, isFastListing } from '@/util/fast-listing'
import { getCurrentCity } from '@/util/location'

NioIcon.add('service_custom', IconService)

export default {
	name: 'index',
	components: {
		ProcessCard,
		ConfigSnapshotCard,
		Skeleton,
		CarRight,
		ContactPopup,
		BottomArea,
		CarReport,
		BasicCard,
		Banner,
		FastListingBanner,
		RecommendCars,
		CarAlbum
	},
	data() {
		return {
			skuCode: supreme.getQueryString('sku_code'),
			headerHeight: 0,

			car: null,
			showContact: false,

			collected: supreme.getQueryString('is_favorite') === 'true',

			inited: false,
			snapshotNo: supreme.getQueryString('snapshot_no'),
			snapshot: supreme.getQueryString('snapshot') === 'true',
			configSnapshot: supreme.getQueryString('config_snapshot') === 'true',
			safeAreaInsetBottom: getSafeInsetBottom(),
			warning: '',
			financeEntry: false,
			isHarmony: hybrid.isHarmony()
		}
	},
	provide() {
		return {
			snapshot: this.snapshot,
			configSnapshot: this.configSnapshot
		}
	},
	created() {
		console.log('%c[AOLIN]', 'color:#3b92de', 'xxx', document.body.clientHeight)
		hybrid.disableWebviewPull()

		this.fetchDetail()
			.then(() => {
				sensors.track('VehicleDetailView', {
					page: '二手车车辆详情页',
					label_name: this.car.$$track_label_name,
					tag: this.car.$$track_tags,
					track_sign: 'aMall.b4307.pageview.VehicleDetailView'
				})
			})
			.finally(() => {
				this.$nextTick(() => {
					this.inited = true
				})
			})

		configModel.getCommonConfig().then(data => {
			this.warning = data.warning || ''
			this.financeEntry = data.finance_entry === true
		})
	},
	computed: {
		isFastListing() {
			return isFastListing(this.car)
		},
		carName() {
			if (!this.car || !this.car.basic) {
				return ''
			}

			const name = this.car.basic.commodity_name || ''
			const brand = BrandMap[this.car.basic.brand]
			return brand ? brand + ' ' + name : name
		},
		skeletonJson() {
			return [
				{
					height: '100vw',
					width: '100vw',
					margin: 0
				},
				{
					width: px2vw(205),
					height: px2vw(33),
					marginTop: px2vw(20),
					marginBottom: px2vw(11)
				},
				{
					width: px2vw(184),
					height: px2vw(22),
					marginBottom: px2vw(31)
				},
				{
					backgroundColor: '#fff',
					marginBottom: px2vw(5),

					subChild: [
						{
							width: px2vw(116),
							height: px2vw(29)
						},
						{
							width: px2vw(116),
							height: px2vw(18)
						}
					]
				},
				{
					width: px2vw(116),
					height: px2vw(18),
					marginBottom: px2vw(31)
				},

				{
					height: px2vw(76),
					marginBottom: px2vw(20)
				},

				{
					backgroundColor: '#fff',
					marginBottom: px2vw(10),

					subChild: [
						{
							width: px2vw(70),
							height: px2vw(20)
						},
						{
							width: px2vw(29),
							height: px2vw(20)
						}
					]
				},

				{
					backgroundColor: '#fff',
					marginBottom: px2vw(60),

					subChild: [
						{
							width: px2vw(28),
							height: px2vw(20)
						},
						{
							width: px2vw(74),
							height: px2vw(20)
						}
					]
				},

				{
					backgroundColor: '#fff',
					marginBottom: px2vw(15),
					justifyContent: 'flex-start',

					subChild: [
						{
							width: px2vw(40),
							height: px2vw(40),
							borderRadius: px2vw(40),
							marginRight: px2vw(10)
						},
						{
							width: px2vw(108),
							height: px2vw(40)
						}
					]
				},

				{
					height: px2vw(275),
					marginBottom: px2vw(20)
				}
			]
		}
	},
	methods: {
		async fetchDetail() {
			try {
				if (this.snapshotNo) {
					// 交易快照的情况
					const { data } = await queryVehicleSnapshot.get({}, '/' + this.snapshotNo + '/snapshot')

					if (!data || data.result_code !== 'success') {
						throw new Error()
					}
					this.car = data.data.commodity_snapshot
				} else {
					// 商城浏览的情况
					const city = await getCurrentCity().catch(() => null)
					const { data } = await queryVehicleDetail.get(
						{
							city_code: city && city.code
						},
						'/' + this.skuCode
					)

					if (!data || data.result_code !== 'success') {
						throw new Error()
					}

					this.car = data.data
					this.$route.meta.car = this.car
				}

				const trackLabelName = getBusinessTypeLabel(this.car.basic.business_type)
				const trackTags = getCarTags(this.car, true)
					.map(tag => tag.label)
					.join(',')

				sessionStorage.setItem('trackLabelName', trackLabelName)
				sessionStorage.setItem('trackTags', trackTags)

				this.car.$$track_label_name = trackLabelName
				this.car.$$track_tags = trackTags
			} catch (e) {
				// this.$router.push({ path: "/error", query: {message: '网络请求失败'}});
			}
		},
		handleRightClick(btn) {
			if (btn === 'icon_service_medium_m') {
				sensors.track('MallItemDetailClick', {
					page: '二手车车辆详情页',
					button_name: '咨询客服',
					sku_code: this.skuCode,
					store: 'PT004'
				})
				this.showContact = true
			} else if (btn === 'icon_share_cn_medium_m') {
				sensors.track('VehicleDetailClick', {
					page: '二手车车辆详情页',
					label_name: this.car.$$track_label_name,
					tag: this.car.$$track_tags,
					module_name: '车辆图片',
					button_name: '分享',
					position_rank: 1,
					position_in_rank: 1,
					position_in_number: 1,
					track_sign: 'aMall.b4307.click.VehicleDetailClick'
				})
				this.share()
			}
		},
		async share() {
			if (!util.isInWebview()) {
				return false
			}
			// 分享点击
			sensors.track('Share', {
				action_name: 'share',
				resource_type: 'goods',
				store: 'PT004',
				sku_code: this.skuCode
			})
			await new Promise(resolve => setTimeout(resolve))

			let shareUrl

			if (hybrid.isCNDo()) {
				shareUrl = `${util.envPath()}/detail?sku_code=${this.skuCode}&header=${encodeURIComponent(
					//JSON.stringify({ backBtColor: "black" })
					JSON.stringify({ isShow: false })
				)}&share=true&wv=do`
			} else {
				shareUrl = `${util.envPath()}/detail?sku_code=${
					this.skuCode
				}&is_nav_show=false&share=true&wv=lg`
			}

			let imgUrl
			if (this.isFastListing) {
				imgUrl = getFastListingCover(this.car)
				imgUrl = imgUrl
					? imgUrl + (imgUrl.indexOf('?') > 0 ? '&' : '?') + 'imageView2/1/format/jpg/w/50/h/50'
					: ''
			} else {
				imgUrl = this.car.photo.appearance.items[0].thpf_url
				imgUrl += imgUrl.indexOf('?') > 0 ? '&' : '?' + 'imageView2/1/format/jpg/w/50/h/50'
			}

			const options = {
				title:
					(this.car.basic.business_type === 1 ? '蔚来官方二手车 ' : '蔚来车主直售 ') + this.carName,
				desc: `一站选购，透明省心\n ¥ ${util.formatCurrency(this.car.sell_programme.sell_price)}`,
				imgUrl: imgUrl || '',
				shareUrl: shareUrl, // 分享链接才有
				function: 'share_webPage'
			}
			const context = {
				data: {
					style: 'poster',
					content: [
						{
							channel: 'weibo',
							...options
						},
						{
							channel: 'wechatfriend',
							...options
						},
						{
							channel: 'wechatcircle',
							...options
						},
						{
							channel: 'niofriend',
							...options
						}
					]
				}
			}

			const res = await hybrid.share2(context)

			console.log('share2', res)

			const data = res && res.data ? res.data : {}

			if (data.platform) {
				sensors.track('Share', {
					action_name: data.platform,
					resource_type: 'goods',
					store: 'PT004'
				})
			}

			if (data.result === 'failed') {
				hybrid.showToast('分享失败')
				return
			}
			if (data.result === 'cancel') {
				hybrid.showToast('分享取消')
				return
			}
			if (data.result === 'success') {
				hybrid.showToast('分享成功')
			}
		},
		handleClose() {
			sensors.track('MallItemDetailClick', {
				page: '二手车车辆详情页',
				button_name: '返回',
				track_sign:
					this.car.basic.business_type === 1
						? 'aMall.b40.d58.click.MallItemDetailClick'
						: 'aMall.b41.d45.click.MallItemDetailClick',
				sku_code: this.skuCode
			})
			hybrid.closeSyn()
		},
		gotoIMchat() {
			// nio://conversation?id=111&type=private|group
			// QA: accountId: "433283967" mobile: "98762754877" imId: "433283967-test"
			// Test: accountId: "198938761" mobile:"98762754874" imId: "198938761-test"
			// STG: accountId: "277599047" mobile: "98762487794" imId: "277599047-staging"
			// console.log('二手车专员聊天窗口link>>>>'+`nio://conversation?id=${util.getEnvInfo().secondHandChatPersonId}&type=private`);
			if (util.isInWebview()) {
				if (!util.isToken()) {
					hybrid.openLoginPage(() => {
						this.openIMchat()
					})
					return
				} else {
					this.openIMchat()
				}
			}
		},

		openIMchat() {
			hybrid.openURL(
				`nio://conversation?id=${util.getBaseEnvInfo().secondHandChatPersonId}&type=private`
			)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.detail-page {
	.snapshot-tips {
		padding: 10px 20px;
		background-color: #f2fcfc;
		color: $text_secondary;
		@include body_3(1.5, 400, false);
	}
	.main-content {
		// padding: 0 20px 124px;
		padding: 0 20px 150px;
	}

	.skeleton-container {
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
		z-index: 100;
		overflow: hidden;
	}

	::v-deep {
		.right-btn-list {
			display: flex;
			align-items: center;

			> :last-child {
				height: 28px;
				margin-left: 15px;
			}
		}
	}

	.warning {
		position: fixed;
		left: 0;
		right: 0;
		padding: 10px;
	}
}
</style>
